import {
  brandsParams,
  GetBrandsParams,
  IgeneratePdf,
  Post,
} from "../../interface/DesignerInterface";
import { User } from "../../types";
import { capitalizeFirstLetter } from "../../utils/commonUtils";
import { admin, forecaster, user } from "./axios";

enum UserGroup {
  Admin = "admin",
  Forecaster = "forecaster",
}

const getAxiosInstance = (group: UserGroup) => {
  switch (group) {
    case UserGroup.Admin:
      return admin;
    case UserGroup.Forecaster:
      return forecaster;
    default:
      throw new Error("Invalid user group");
  }
};
const getDesignerFocusPosts = async (
  params: {
    page?: number;
    pageSize?: number;
    startDate?: string;
    endDate?: string;
    genre?: string;
    product?: string;
    gender?: string;
    region?: string;
    searchQuery?: string;
    colors?: string;
    category?: string;
    s3Key?: string;
    bucketName?: string;
  },
  options?: { signal?: AbortSignal }
) => {
  const response = await user.get("designer-focus/posts", {
    params,
    signal: options?.signal,
  });

  const filteredPosts = response.data.data.posts.filter(
    (post: Post) => !post.is_video
  );

  return {
    ...response.data,
    posts: filteredPosts,
  };
};

export const searchDesignerFocusPosts = async (params: {
  page?: number;
  pageSize?: number;
  query: string | undefined;
}) => {
  const response = await user.get("designer-focus/search", {
    params,
  });
  const filteredPosts = response.data.data.posts.filter(
    (post: Post) => !post.is_video
  );

  return {
    ...response.data,
    posts: filteredPosts,
  };
};

const getDropdownData = async () => {
  const response = await user.get(`/targets/targetoptions`);
  return response.data.data;
};

const getBrandsData = async (params: GetBrandsParams) => {
  const response = await user.get(`/designer-focus/brands`, { params });
  return response.data.data;
};

const getProducts = async () => {
  const response = await user.get(`/designer-focus/products`);
  const products = response.data.data.filter(
    (product: string) => product !== "N/A" && product !== "None"
  );

  return products;
};

const generatePdf = async (payload: IgeneratePdf, user: User | null) => {
  if (user === null) {
    throw new Error("User is not available");
  }
  const { group } = user!;
  if (group) {
    try {
      if (group === "admin") {
        const response = await admin.post(`/report-generation`, payload);
        return response.data.data;
      } else if (group === "forecaster") {
        const response = await forecaster.post("/report-generation", payload);
        return response.data.data;
      }
    } catch (error) {
      console.error("Error generating content:", error);
      throw error;
    }
  } else {
    console.error("Group Not Found");
  }
};

export {
  getDesignerFocusPosts,
  getDropdownData,
  getBrandsData,
  getProducts,
  generatePdf,
};
